import { render } from "./UploadImage.vue?vue&type=template&id=33cbd761&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=33cbd761&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cbd761"]])

export default __exports__